import React from 'react';
import BaseModal from '../../utils/BaseModal/BaseModal';
import {
  CloseButton,
  ShareOptionButton,
  ShareOptionLabel,
  ShareOptionsScroller,
  ShareSheet,
  ShareTitle,
  SheetHeader,
} from './ReelShareModal.styles';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as TelegramIcon } from '../../../assets/icons/telegram.svg';
import { ReactComponent as CopyIcon } from '../../../assets/icons/copy.svg';
import { ReactComponent as RepostIcon } from '../../../assets/icons/repost.svg';
import { ReactComponent as ShareIcon } from '../../../assets/icons/share-01.svg';

const primaryShareOptions = [
  { value: 'copy_link', label: 'Copy Link', icon: CopyIcon },
  { value: 'telegram', label: 'Telegram', icon: TelegramIcon },
  { value: 'other', label: 'More', icon: ShareIcon },
];

const secondaryShareOptions = [{ value: 'repost', label: 'Repost', icon: RepostIcon, fullWidth: true }];

const ReelShareModal = ({ isOpen, onClose, onShareOptionClick }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      desktopMode="dialog"
      desktopMaxWidth="56rem"
      customOverlayStyles={{ backgroundColor: 'rgba(3, 5, 9, 0.56)' }}
      customModalStyles={{ width: '100%' }}>
      <ShareSheet>
        <SheetHeader>
          <ShareTitle>Share</ShareTitle>
          <CloseButton type="button" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </SheetHeader>
        <ShareOptionsScroller $columns={primaryShareOptions.length}>
          {primaryShareOptions.map(({ value, label, icon: Icon, fullWidth }) => (
            <ShareOptionButton
              key={value}
              type="button"
              $fullWidth={fullWidth}
              onClick={() => onShareOptionClick(value)}>
              <Icon width={24} height={24} />
              <ShareOptionLabel>{label}</ShareOptionLabel>
            </ShareOptionButton>
          ))}
        </ShareOptionsScroller>
        {secondaryShareOptions.map(({ value, label, icon: Icon, fullWidth }) => (
          <ShareOptionButton key={value} type="button" $fullWidth={fullWidth} onClick={() => onShareOptionClick(value)}>
            <Icon width={24} height={24} />
            <ShareOptionLabel>{label}</ShareOptionLabel>
          </ShareOptionButton>
        ))}
      </ShareSheet>
    </BaseModal>
  );
};

export default ReelShareModal;
